export default __webpack_public_path__ + "static/media/LeaderboardPrimary.e697ce29.svg";